import React from 'react'
import Recaptcha from 'react-google-recaptcha'
import PropTypes from 'prop-types'
import CONFIG from '../../../config/config'

const { siteKey } = CONFIG.captcha

class CaptchaComponent extends React.Component {
    render() {
        const { input, formProps } = this.props

        return <div>
            <Recaptcha
                {...input}
                {...formProps}
                sitekey={siteKey}
                onChange={(response) => input.onChange(Boolean(response))}
            />
        </div>
    }
}

CaptchaComponent.propTypes = {
    input: PropTypes.object.isRequired,
    formProps: PropTypes.object.isRequired,
}

export default CaptchaComponent



// WEBPACK FOOTER //
// ./src/components/core/CaptchaComponent/CaptchaComponent.js